import React, { lazy } from 'react';

import Loadable from 'react-loadable';

import { fg } from '@atlaskit/platform-feature-flags';
import Suspense from '@atlaskit/react-ufo/suspense';

import { importFeedbackFlag } from './import-feedback-flag';

const LazyFeedbackFlagComponent = lazy(() =>
	importFeedbackFlag().then((module) => ({
		default: module.FeedbackFlagComponent,
	})),
);

const LoadableFeedbackFlagComponent = Loadable({
	loader: () => importFeedbackFlag().then(({ FeedbackFlagComponent }) => FeedbackFlagComponent),
	loading: () => null,
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AsyncFeedbackFlagComponent = (props: any): React.ReactElement => {
	if (fg('aimate_conversation_assistant_async_loading')) {
		return React.createElement(Suspense, {
			fallback: null,
			interactionName: 'rovo-conversation-assistant-feedback-flag',
			children: React.createElement(LazyFeedbackFlagComponent, props),
		});
	}
	return React.createElement(LoadableFeedbackFlagComponent, props);
};
